import { useListBanksOptions } from "views/Clients/hooks/useListBanksOptions";
import { usePermissions } from "hooks/usePermissions";
import useCoreStore from "views/hooks/useCoreStore";
import useGeneralApi from "./useGeneralApi";
import { FormInstance } from "antd";
import { useEffect } from "react";
import { useParams } from "react-router-dom";

export const useBankData = ({ form }: { form: FormInstance }) => {
  const {
    listDefaultPaymentMethods,
    paymentMethodsOptions,
    listCompaniesBankAccountsPaginated,
    companiesBankAccountsData: data,
    listCompanyBankPaginatedRefetch: refetchCompanyBanks,
  } = useGeneralApi(undefined, form);

  const { listBanks, banksOptions, refetchListBanks } = useListBanksOptions();
  const { companyId } = useParams();
  const companySettings = useCoreStore(state => state.companySettings);
  const mainBank = data?.filter(item => item.isMain === true);
  const { canViewPaymentMethods } = usePermissions();

  useEffect(() => {
    listBanks({
      variables: {
        filter: {
          companyId_In: companyId ? [companyId] : undefined,
        },
        limit: 10,
        offset: 0,
      },
    });
    if (canViewPaymentMethods) {
      listDefaultPaymentMethods({
        variables: {
          filter: {
            accountingFirm_Isnull: true,
          },
        },
      });
    }
  }, [canViewPaymentMethods]);

  useEffect(() => {
    if (companySettings?.defaultBank?.id) {
      form.setFields([
        {
          name: "defaultBankInstitutionId",
          value: companySettings.defaultBank.id,
        },
        {
          name: "defaultBankAccountId",
          value: companySettings.defaultBankAccount?.id,
        },
      ]);
    } else if (mainBank?.[0]) {
      form.setFields([
        {
          name: "defaultBankAccountId",
          value: mainBank[0].id,
        },
      ]);
    }

    if (companySettings?.defaultPaymentMethods) {
      const activeOptions = companySettings.defaultPaymentMethods
        .filter(item => item.code !== "RE")
        .map(item => String(item.id));

      form.setFieldsValue({
        defaultPaymentMethods: activeOptions,
      });
    }
  }, [companySettings]);

  return {
    data,
    banksOptions,
    refetchListBanks,
    refetchCompanyBanks,
    paymentMethodsOptions,
    listCompaniesBankAccountsPaginated,
  };
};
